export const serviceDeliveryOptionLabels: { [key: string]: string } = {
    "in_person": "In-Person",
    "remote": "Telemed"
}

export const SESSION_ATTENDEE_SUPPORTED_SERVICES = [
    "Couples Therapy",
    "Family Therapy",
];
